export namespace Constants {
	export const NUMBER_PADDING = 3;

	export const ARTICLE_GROUP_NUMBER_PREFIX = "M";
	export const ARTICLE_GROUP_NUMBER_PADDING = NUMBER_PADDING;

	export const ARTICLE_PRODUCT_TYPE_NUMBER_PREFIX = "";
	export const ARTICLE_PRODUCT_TYPE_NUMBER_PADDING = NUMBER_PADDING;

	export const ARTICLE_NUMBER_PREFIX = "";
	export const ARTICLE_NUMBER_PADDING = NUMBER_PADDING;

	export const ORDER_NUMBER_PREFIX = "B";
	export const ORDER_NUMBER_PADDING = 6;

	export const SUBORDER_NUMBER_PREFIX = "S";
	export const SUBORDER_NUMBER_PADDING = 2;

	export const RETURN_ORDER_NUMBER_PREFIX = "R";
	export const RETURN_ORDER_NUMBER_PADDING = 6;

	export const TRANSPORT_ORDER_NUMBER_PREFIX = "T";
	export const TRANSPORT_ORDER_NUMBER_PADDING = 6;

	export const NUMBER_JOINER = ".";
}
